<template>
  <button class="btn btn-link custom-link" href="#" role="button" v-on:click="onClick()">
    <slot v-if="!loading"></slot>
    <i v-else class="fa fa-spinner fa-spin"></i>
  </button>
</template>

<style scoped>
.custom-link {
  padding: 0px;
}
</style>

<script>
export default {
  props: ["loading"],
  data() {
    return {};
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  },
  created() {}
};
</script>
